/* eslint-disable react/prop-types */
import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import parse from "html-react-parser";

const PopUpMessage = ({ message }) => {
  const [showDialog, setShowDialog] = useState(true);

  if (!showDialog) return null;

  return (
    <AlertDialog open={showDialog} onOpenChange={setShowDialog}>
      <AlertDialogContent className="dark:border-darkBorder dark:bg-darkInput z-[99999] w-[350px] rounded-2xl border-gray-200 bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-bold">
            Service Update
          </AlertDialogTitle>
          <AlertDialogDescription className="text-gray-600 dark:text-gray-200">
            {parse(message)}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            onClick={() => setShowDialog(false)}
            className="w-full cursor-pointer font-normal text-white"
          >
            Close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default PopUpMessage;
